module.exports = __webpack_public_path__ + "media/images/brand/400/MARQUESBRANDINGCO LOGO ORIGINAL X-679bcb5210b5dfdc07bddbb13875a0b2.png";